import { get } from 'lodash-es';
import { reportTypesOptions } from './research-library-config';
import { getGlobalSettings } from '../../../utils/global_settings';

export const rootNode = document.getElementById('reports-and-exports-page-root');

export const initParams = {
  permissions: {
    ...getGlobalSettings().permissions,
    ...JSON.parse(rootNode.dataset.permissions || '{}'),
  },
  currentUser: JSON.parse(rootNode.dataset.currentUser),
  isLoggedUser: JSON.parse(rootNode.dataset.loggedUser),
  filtersOptions: {
    geographyOptions: JSON.parse(rootNode.dataset.geographyOptions),
    reportTypesOptions: JSON.parse(rootNode.dataset.reportTypesOptions),
    gicsSectorsOptions: JSON.parse(rootNode.dataset.gicsSectorsAllOptions),
    marketCapOptions: JSON.parse(rootNode.dataset.marketCapOptions),
  },
  prefferedOptions: JSON.parse(rootNode.dataset.prefferedOptions),
  freeSampleReportId: rootNode.dataset.freeSampleReportId,
  hasFirstVisitAlert: rootNode.dataset.showFirstVisitAlert === 'true',
  downloadMarketReportUrl: rootNode.dataset.downloadMarketReportUrl,
  downloadCustomS3ReportUrl: rootNode.dataset.downloadCustomS3ReportUrl,
  downloadReport: JSON.parse(rootNode.dataset.downloadReport || 'null'),
  downloadExport: JSON.parse(rootNode.dataset.downloadExport),
  kpiForecastsDatapacksUrl: rootNode.dataset.kpiForecastsDatapacksUrl,
};

export const {
  permissions,
  isLoggedUser,
  filtersOptions,
  freeSampleReportId,
  prefferedOptions,
  downloadMarketReportUrl,
  downloadCustomS3ReportUrl,
  downloadReport,
  downloadExport,
} = initParams;

export const pagesList = [
  {
    name: 'KPI Forecasts',
    value: 'kpi-forecasts',
    allowed: permissions.allowForecasts,
    hidden: !permissions.allowForecasts,
  },
  {
    name: permissions.finance_customer ? 'Custom Research' : 'Market Reports',
    value: 'market-reports',
    allowed: permissions.allowMarketReports,
    hidden: !permissions.allowMarketReports,
  },
  {
    name: 'Research Library',
    value: 'research-library',
    allowed: permissions.allowResearchLibrary,
    hidden: !permissions.allowResearchLibrary,
  },
  {
    name: 'Exports',
    value: 'exports',
    allowed: permissions.allowCustomExports || permissions.paid,
    hidden: true,
  },
];

export const baseURL = '/my_reports';

export const predefinedPage = (() => {
  let page;

  if (downloadCustomS3ReportUrl || downloadExport) {
    page = 'exports';
  } else if (downloadReport) {
    page = 'research-library';
  } else if (downloadMarketReportUrl) {
    page = 'market-reports';
  } else {
    page = (pagesList.find(({ value }) => window.location.hash.startsWith(`#${value}`)) || {})
      .value;
  }

  if (page) {
    const isPageAllowed = pagesList.some((item) => item.value === page && item.allowed);
    if (isPageAllowed) return page;
  }
  const allowedPage = pagesList.find((item) => item.allowed);

  return allowedPage ? allowedPage.value : 'research-library';
})();

export const defaultState = {
  currentPage: predefinedPage,
  marketReports: {
    data: [],
    settings: {
      pending: true,
      error: false,
    },
    filters: {
      order_by: 'date_from', // name, date_from, cadence
      order_dir: 'desc',
      pagination: {
        total: 0,
        per_page: 5,
        current_page: 0,
      },
    },
  },
  researchLibrary: {
    data: [],
    tickers: [],
    settings: {
      pending: true,
      error: false,
    },
    filters: {
      type: reportTypesOptions(permissions)[0],
      eventId: null,
      filters: {},
      pagination: {
        page: 1,
        total_count: null,
      },
    },
  },
  customExports: {
    data: [],
    selectedExports: [],
    settings: {
      pending: true,
      error: false,
    },
    filters: {
      query: null,
      sort_by: 'created_at',
      sort_order: 'desc',
      only_scheduled: 'false',
      pagination: {
        total: 0,
        per_page: get(prefferedOptions, 'custom_exports.per_page', 10),
        current_page: 0,
      },
    },
  },
  customReports: {
    data: [],
    settings: {
      pending: permissions.custom_reports,
      error: false,
    },
    filters: {
      query: null,
      sort_by: 'created_at',
      sort_order: 'desc',
      pagination: {
        total: 0,
        per_page: get(prefferedOptions, 'custom_reports.per_page', 10),
        current_page: 0,
      },
    },
  },
  versionHistory: {
    data: [],
    settings: {
      pending: true,
      error: false,
    },
    filters: {
      custom_report_id: 0,
    },
  },
  forecasts: {
    data: {},
    settings: {
      pending: true,
      error: false,
    },
  },
  currentForecast: {
    data: {},
    settings: {
      pending: true,
      error: false,
    },
    filters: {},
  },
};
